import { put, call } from "redux-saga/effects";

import { GET_COMMONCATEGORY_COMPLETED,GET_COMMONCATEGORY_FAILED} from "../actions/Commoncategory";

import {CommoncategoryAPI } from "../../utils/api/CommoncategoryAPI";

export function* getCOMMONCATEGORY(request: any) {
    try {
      const result = yield call(CommoncategoryAPI.getcommoncategory,request.input);
   
    //  var status = result.data;
    
          yield put({
              type: GET_COMMONCATEGORY_COMPLETED,
              payload: result.data,
              input: request.input
          });        
          
      } catch (e) {        
          yield put({ type: GET_COMMONCATEGORY_FAILED, payload: e.message });
      }
  }